import { render, staticRenderFns } from "./TeachingDataTable.vue?vue&type=template&id=2d918030"
import script from "./TeachingDataTable.vue?vue&type=script&lang=js"
export * from "./TeachingDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports